.progressbar{
    width: 100%;
    height: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 0 3px;
}
.progressbar svg {
    border-radius: 5px;
}
.bgprogress{
    fill: #6767675c;
    box-shadow:  0 0 0 1px #6767675c;
}
